module.exports = __webpack_public_path__ + "img/support2.8d12c6b4.svg";